<template>
  <main class="content">
      <div class="row">
          <h1>
              Edit featured video
          </h1>
      </div>
      <form action="" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
          <fieldset class="form--item">
              <label class="label" for="">
                  Youtube or Vimeo Link:
              </label>
              <div class="input_text">
                  <input name="" placeholder="Paste a URL link from a Youtube or Vimeo video" type="text" required v-model="featured.videoDetails.link" />
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Partner:
              </label>
              <div class="input_text">
                  <v-select v-model="featured.partnerId" required :searchable="false" placeholder="Pick a partner" :options="partners"></v-select>
              </div>
          </fieldset>
          <div class="row">
              <a class="btn btn_green u-fleft u-mr1" @click="updatePartner()">
                  Update
              </a>
              <a class="btn btn_red u-fleft" @click="confirmToggle()">
                  Delete
              </a>
          </div>
      </form>
      <confirm resource="featured video" :visible.sync="alertVisible"></confirm>
      <ok resource="featured video" resource-plural="featured videos" :visible.sync="okVisible"></ok>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import * as EditResource from '../../mixins/editResource.mixin';
import * as ValidateForm from '../../mixins/validate-form.mixin';

import Confirm from '../Modals/modal_confirm';
import Ok from '../Modals/modal_ok';
import vSelect from "vue-select"
import Loading from '../Loading.vue'
import Message from '../Message.vue'

export default {
  name: 'EditFeatured',
  components: { Confirm, Ok, vSelect, Loading, Message },
  mixins: [ValidateForm, EditResource],

  data () {
    return {
      model: 'featured',
      resource: 'featured',
      parentResource: 'Featured',
      alertVisible: false,
      okVisible: false,
      featured: {
        videoDetails: {}
      },
      partners: []
    }
  },
  created(){
    var self = this;
    HttpService.index('partners', {
        /*stripeAccountLinked: true*/
    }, function(response, error){
      self.partners = response.result.data;
      self.partners = self.partners.map(item => {
        return {value: item.id, label: item.name}
      });
    });
  },
  mounted(){
    this.fetchResource(this.$route.params.id, {});
  },
  methods: {
    updatePartner(){
      // return;
      let featured = {
        link: this.featured.videoDetails.link,
        partnerId: this.featured.partnerId.value
      }
      this.updateResource(this.$route.params.id, featured);
    }
  },
  watch: {
    'featured.partner': function(val, change){
      this.featured.partnerId = this.partners.find(item => item.value == this.featured.partner);
    },
    'partners': function(val, change){
      this.featured.partnerId = this.partners.find(item => item.value == this.featured.partner);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditFeatured.vue?7d9b1d3c